import type { FC } from 'react';

import { WarningBanner } from '@web/components/Banner/WarningBanner';

type Props = {
  message: string;
  editorName: string | null;
};

export const QuoteEditLockNotice: FC<Props> = ({ message, editorName }) => (
  <WarningBanner title={message}>
    {`You're viewing the current version in view-only mode. Fields stay disabled until ${editorName ?? 'the other editor'} saves or closes the form.`}
  </WarningBanner>
);
